import React, { Component } from "react";
import T from "../t/T";
import "./Modal.scss";

class Modal extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.show === true && this.props.closeable === true) {
            document.addEventListener("keydown", this.keyPressESC)
        }
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.keyPressESC);
    }

    keyPressESC = (event) => {
        if (event.key === "Escape") {
            this.closeModal()
        }
    }
	
	closeModal = () => {
		this.props.closeModal()
	}

    // Lifecycle methods

    // Private methods

    // Public methods
    handleCloseModal = (e, closeable) => {
        let close = document.getElementsByClassName("mmodal__close-btn")[0]
        let a = document.getElementsByClassName("mmodal__container")[0]
        if (close.contains(e.target) || (closeable && e.target.contains(a))) {
            this.closeModal()
        }
    }

    render() {
        const { show = true, className = "", logo = null, title = "", description = "", closeable = false, children, footer } = this.props;
        return <>
            {show && <div className={className}>
                <div className="mmodal" onClick={(e) => this.handleCloseModal(e, closeable)}>
                    <div className="mmodal__container">
                        <span>
                            <button className="mmodal__close-btn" >
                                <i className="fal fa-times-circle"  onClick={this.closeModal}/>
                            </button>
                        </span>
                        <div className="mmodal__content">
                            <div className="mmodal__header">
                                {logo && <img className="mmodal__logo" src={logo} alt="Spax logo" />}
                                {!!title.length && <p className="mmodal__title"><T token={title} /></p>}
                                {!!description.length && <p className="mmodal__description"><T token={description} /></p>}
                            </div>
                            <div className="mmodal__body">
                                {
                                    children
                                }
                            </div>
                        </div>
                        <div className="mmodal__footer">
                            {
                                footer
                            }
                        </div>
                    </div>
                </div>
            </div>
            }
        </>
    }
}

export default Modal;
